import styled from '@emotion/styled';
import { Tile } from '@hotjar/activation-toolkit';
import { Icon, Text, Link, tokens } from '@hotjar/hotsauce';
import { CountryFlag } from '@hotjar/country-lib';

export const Container = styled.div`
  text-align: left;
  padding: ${tokens.spacer.x2pt5} ${tokens.spacer.x2};
  border-top: 1px solid ${tokens.color.ui_border};

  ${tokens.text('caption')};
`;

export const Row = styled.div`
  ${tokens.text('caption')}
  display: flex;
  align-items: center;
  margin: ${tokens.spacer.x2} 0;
  ${tokens.truncateText()}
`;

export const IconSpaced = styled(Icon)`
  flex-shrink: 0;
  margin-right: ${tokens.spacer.x1};
`;

export const Title = styled.div`
  ${tokens.text('subtitle2')};
  margin: 0 0 ${tokens.spacer.x1};
  display: flex;
  align-items: center;
`;

export const DivOverflow = styled.div`
  ${tokens.truncateText()}
  ${tokens.text('caption')};
`;

export const Unknown = styled.span`
  font-style: italic;
  color: ${tokens.color.text_light};
`;

export const ScrollContainer = styled.div`
  overflow-y: auto;
  flex-grow: 1;
`;

export const Flag = styled(CountryFlag)`
  margin-right: ${tokens.spacer.x1};
`;

export const TextOverflow = styled(Text)`
  ${tokens.truncateText()}
`;

export const StyledLink = styled(Link)`
  margin-right: ${tokens.spacer.x1};
`;

export const TileContainer = styled.div`
  padding: ${tokens.spacer.x2} ${tokens.spacer.x4};
`;

export const StyledTile = styled(Tile)`
  text-align: left;
  width: 100%;

  > a {
    text-decoration: none;
  }
`;
